export const modeLabels={BESTAND:'Aus · bisherige Engine',VERGLEICH:'Mitrechnen · keine Kundenpreise',PULSE:'Aktiv · alleinige Preisquelle'};
export const modeLabel=value=>modeLabels[value]||'Unbekannt · Betriebsstand laden';
export function openOperatingTarget(href,documentRoot=document){
 const target=documentRoot.querySelector(href);
 if(!target)return false;
 const details=target.matches?.('details')?target:target.querySelector?.('details');
 if(details)details.open=true;
 target.scrollIntoView?.({block:'start'});
 return true;
}
